export default {
  error: state => state.error,
  formLoading: state => state.formLoading,
  exportLoading: state => state.exportLoading,
  success: state => state.success,
  loading: state => state.loading,
  coowner: state => state.coowner,
  coowners: state => state.coowners,
  downloadCoownersLink: state => state.downloadCoownersLink,
  section: state => state.section,
  allFields: state => state.allFields,
  getfields: state => state.getfields,
  imageURL: state => state.imageURL,
  coownerSectionPermission: state => state.coownerSectionPermission,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Coowners/getters.js